import axios from 'axios';
import { dispatchCusEvent, messageByCode } from '../utils';
import { ENUM_CUS_EVENT, ENUM_TOAST_TYPE, TEST_MODE } from '../enums/enums';

export const API_URL = '/api';
export const PREFIX = TEST_MODE ? 'https://devf.securebet.xyz' : '';

axios.interceptors.response.use((response) => {
  if (response.data.message === 'Unauthenticated.') {
    localStorage.clear();
    window.location.href = '/';
  }
  return response;
});

const errorTranslation = {
  message: 'an unknown error was received',
  type: ENUM_TOAST_TYPE.error
};

// skipCodeErrorList - массив ошибок которые не нужно показывать пользователю
export const cusAxios = (props, skipCodeErrorList = [], isReturnError = false) =>
  new Promise((resolve, reject) => {
    if (TEST_MODE) {
      reject({});
      return;
    }

    axios({ ...props, headers: { 'Content-Type': 'application/json' } })
      .then((response) => {
        const data = response.data;

        if (skipCodeErrorList.includes(data?.dataError)) {
          reject(data);
          return;
        }

        if (typeof data !== 'object' || typeof data === 'undefined') {
          if (isReturnError) {
            reject(data);
            return;
          }

          dispatchCusEvent(ENUM_CUS_EVENT.translationToast, errorTranslation);
          reject();
          return;
        }

        const error = data.error ?? data.dataError;

        if (data.error && isReturnError) {
          reject({ error: data.error, dataError: data.dataError });
          return;
        }

        if (error || error === '') {
          if (TEST_MODE) return;

          if (data.dataError === 604) {
            window.location.href = '/';
            localStorage.clear();
            reject();
          }

          const messageError = data.dataError
            ? messageByCode(data.dataError)
            : data.error || 'an error occurred';
          const dataTranslation = { message: messageError, type: ENUM_TOAST_TYPE.error };

          dispatchCusEvent(ENUM_CUS_EVENT.translationToast, dataTranslation);

          reject(messageError);
          return;
        }

        resolve(response);
      })
      .catch((e) => {
        dispatchCusEvent(ENUM_CUS_EVENT.translationToast, errorTranslation);
        reject(e);
      });
  });

// export const thenMessageServer = (e) => {
//   const messages = messageByText();

//   const data = e.data;
//   if (!data) return errorToast(messages.unexpected);

//   if (data.status || data.ok) {
//     if (data.message) successToast(data.message);
//     return;
//   }

//   return errorToast(data.message || messages.unknown);
// };

// export const catchMessageServer = (e) => {
//   if (typeof e === "string") return errorToast(e);
//   const messages = messageByText();

//   if (!e.response?.data) return errorToast(messages.notRespond);
//   return errorToast(e.response?.data?.message || messages.unknown);
// };
